/**
 * @param {array} combinedQuestions Array de perguntas combinadas.
 * @returns - payload que será utilizado na requisição do passo 3. Enviamos uma requisição
 * para recuperar a lista de alternativas com base no grupo de perguntas combinadas 
 */
export const getGroupQuestionsPayload = function(combinedQuestions = []) {
  return combinedQuestions.map(({ id, group }) => ({
      uuid_grupo: id,
      perguntas: group.map(({ id: surveyAndQuestionId }) => {
        const [surveyId, questionId] = surveyAndQuestionId.split('_');

        return {
          id_pergunta: questionId,
          id_pesquisa: surveyId,
        }
      }),
  }));
};

/**
 * Mapeia uma lista de perguntas para um array com seus respectivos id's de pesquisa.
 * @param {array} questionList 
 * @returns {array<number>} Array com os ids relativos à pesquisa de cada pergunta.
 */
export const mapQuestionsToSurveyIdList = function(questionList = []) {
  return questionList.map(({ id }) => {
    const [surveyId] = id.split('_');

    return Number(surveyId);
  });
}